<template>
    <!-- 이용약관 -->
    <div class="terms" v-html="this.content"></div>
</template>

<script>
import { fetchData } from '@/utils/fetchData';
export default {
    mixins: [ fetchData ],
    data(){
        return {
            content: '',
        }
    },
    created(){
        this.fetchData('/getPolicy?page=term', (data)=>{
            this.content = data.policy.content;
        })
    }
}
</script>